import { useState } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Banner, Box, Button, Text } from '@betterment/samba-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import StepHeading from '../../../AccountCreationFlow/components/StepHeading';
import { TermsAndAgreementsOption } from '../../../graphql/schema';
import FullPageLoader from '../../../Shared/components/FullPageLoader';
import { TermsAndAgreementsBlock } from '../../../Shared/components-v2/terms-and-agreements/TermsAndAgreementsBlock';
import { WorkflowLayout } from '../../../Shared/layout/WorkflowLayout';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { TermsAndAgreementsDocument } from '../../graphql/query.termsAndAgreements.generated';

export const AccountTermsAndAgreements: React.FC = () => {
  const [creationErrors] = useState<string[]>([]);

  const selectedTermsAndAgreements: TermsAndAgreementsOption[] = [
    TermsAndAgreementsOption.DirectTrading,
    TermsAndAgreementsOption.SecuritiesLending,
  ];

  const { data } = useGraphQLQuery(TermsAndAgreementsDocument, {
    variables: { filter: { termsAndAgreementsOptions: selectedTermsAndAgreements } },
    throwOnError: true,
  });

  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const navigate = useNavigate();

  if (!data) return <FullPageLoader />;

  return (
    <WorkflowLayout
      pageTitle="Terms and Agreement"
      workflowTitle=""
      onBack={() => navigate(-1)}
      onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
    >
      <Box css={{ display: 'grid', gap: 'space.300' }}>
        <StepHeading>Review and confirm terms.</StepHeading>
        {data.termsAndAgreements.map(termsAndAgreement => (
          <TermsAndAgreementsBlock key={termsAndAgreement.title} termsAndAgreement={termsAndAgreement} />
        ))}
        <Text>By clicking confirm, I acknowledge that I have read and agree to the terms above.</Text>
        {creationErrors.length > 0 &&
          creationErrors.map((errorMessage: string) => (
            <Banner variant="critical" key={errorMessage}>
              <Banner.Content>
                <Text>{errorMessage}</Text>
              </Banner.Content>
            </Banner>
          ))}
        <Box css={{ display: 'flex' }}>
          <Button
            onClick={() => navigate(urlBuilder.appAddAccountDirectTradingConfirmation.path)}
            variant="solidPrimary"
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </WorkflowLayout>
  );
};
